import { useState, useEffect } from 'react';
import { FREE_SHIPPING_BAR_DEFAULTS } from '../constants/freeShippingBarDefaults';

/**
 * Custom hook for managing Free Shipping Bar settings
 *
 * @param {Object} initialSettings - Initial settings object from WordPress
 * @returns {Object} { settings, setSettings, loading, setLoading }
 */
export function useFreeShippingBarSettings(initialSettings = {}) {
  const [settings, setSettings] = useState(FREE_SHIPPING_BAR_DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Merge initial settings with defaults
    setSettings(prevSettings => ({
      ...prevSettings,
      ...initialSettings,
    }));
    setLoading(false);
  }, [initialSettings]);

  return {
    settings,
    setSettings,
    loading,
    setLoading,
  };
}
